import { Component, inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    imports: [MatFormField, MatLabel, MatInput, FormsModule, MatButton]
})
export class LoginComponent {
  private authService = inject(AuthService);
  private router = inject(Router);

  public apiKey: string = null;

  constructor() {
    const authService = this.authService;

    this.apiKey = authService.apiKey;
  }


  public login() {
    this.authService.onSignIn(this.apiKey);
    if(this.authService.isAuthenticated) {
      this.router.navigate(['home']);
    }
  }
}
